export const onboarding = {
  namespaced: true,
  state: {
    chosenCamera: null
  },
  mutations: {
    storeChosenCamera(state, camera) {
      state.chosenCamera = camera;
    }
  }
}